export { default as fifteen } from './fifteen';
export { default as twenty } from './twenty';
export { default as thirty } from './thirty';
export { default as forty } from './forty';
export { default as eighty } from './eighty';
export { default as social } from './social';
export { default as navigation } from './navigation';
export { default as others } from './others';

export const FILTERS = [
  {
    key: 'all',
    value: 'all'
  },
  {
    key: '15',
    value: '15px',
  },
  {
    key: '20',
    value: '20px',
  },
  {
    key: '30',
    value: '30px',
  },
  {
    key: '40',
    value: '40px',
  },
  {
    key: '80',
    value: '80px',
  },
  {
    key: 'navigation',
    value: 'navigation',
  },
  {
    key: 'other',
    value: 'other',
  },
  {
    key: 'social',
    value: 'social media',
  },
];

export const FILTERKEYS = {
  '15'       : '15 px',
  '20'       : '20 px',
  '30'       : '30 px',
  '40'       : '40 px',
  '80'       : '80 px',
  navigation : 'Navigation',
  other      : 'Others',
  social     : 'Social Media'
};



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/index.js